module.exports = __webpack_public_path__ + "img/thumbnail_PygmyHippo_j_normal.d2e726e4.png";